import Image from 'next/image'
import { FC } from 'react'

import {
  RequestTypeAlias,
  RequestTypeType
} from '@/api/models/requests/lib/requests.types'
import { cn } from '@/app/utils'

import styles from './PassTypesSelectorFormBlock.module.css'

type Props = {
  name: string
  options: RequestTypeType[]
  alias: RequestTypeAlias
  onChange: (e: RequestTypeType) => void
}

const PassTypesSelectorFormBlock: FC<Props> = ({
  name,
  options,
  alias,
  onChange
}) => {
  return (
    <div className="grid grid-cols-4 gap-8 lg:grid-cols-2">
      {options.map(option => (
        <label
          key={option.alias}
          className={cn(
            'cursor-pointer rounded-12 border border-grey-30 p-16 transition',
            {
              '-my-1 border-2 border-beige-70 bg-white': alias === option.alias
            }
          )}
        >
          <input
            name={name}
            type="radio"
            checked={alias === option.alias}
            className="hidden"
            onChange={() => onChange(option)}
          />
          {option.iconLink && (
            <div className="mb-16">
              <Image
                width={30}
                height={30}
                src={option.iconLink}
                alt={option.name}
                className={cn(
                  alias === option.alias && styles.icon,
                  'object-contain'
                )}
              />
            </div>
          )}
          <p
            className={cn('font-pro text-grey-100 text-14', {
              'font-bold': alias === option.alias
            })}
          >
            {option.name}
          </p>
        </label>
      ))}
    </div>
  )
}

export { PassTypesSelectorFormBlock }
